import { Flex } from "@chakra-ui/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomeScreen from "./screens/HomeScreen";
import Header from "./components/custom/Header";
import Footer from "./components/custom/Footer";
import AboutScreen from "./screens/AboutScreen";
import ContactScreen from "./screens/ContactScreen";
import ITRFilingScreen from "./screens/ITRFilingScreen";
import GSTFilingScreen from "./screens/GSTFilingScreen";
import BusinessScreen from "./screens/BusinessScreen";
import ExpertCAScreen from "./screens/ExpertCAScreen";
import FormScreen from "./screens/FormScreen";
import PaymentScreen from "./screens/PaymentScreen";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import ErrorScreen from "./screens/ErrorScreen";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 500,
      once: false,
      mirror: true,
      easing: "linear",
      offset: 200,
    });
  }, []);
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Header />
        <Flex
          direction="column"
          as="main"
          bg={{ base: "#F6FAFF", _dark: "#0f031b" }}
        >
          <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/about" element={<AboutScreen />} />
            <Route path="/contact" element={<ContactScreen />} />
            <Route path="/itr-filing" element={<ITRFilingScreen />} />
            <Route path="/gst-filing" element={<GSTFilingScreen />} />
            <Route path="/business-registration" element={<BusinessScreen />} />
            <Route path="/expert-assistance" element={<ExpertCAScreen />} />
            <Route path="/itr-form" element={<FormScreen />} />
            <Route path="/payments" element={<PaymentScreen />} />
            <Route path="*" element={<ErrorScreen />} />
          </Routes>
        </Flex>
        <Footer />
      </BrowserRouter>
    </HelmetProvider>
  );
};

export default App;
